import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flex, Spin } from "antd";
import nodatafound from "../../../../../Assets/Icons/NoDataCard2.svg";
import VitalConfigurationTable from "./configurationTable";
import { fetchRpmVitalsRangeList } from "../../../../../Redux/actions/rpmActions";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";

function Index({ currPageView, handleCancel, handleNext, handlePrevious }) {
  const [checked, setChecked] = useState([]);
  const { isLoading, vitalRangesList } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients
  );
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (Array.isArray(selectedEditPatient?.patientVitalsRangeList)) {
      setChecked(selectedEditPatient.patientVitalsRangeList);
    } else {
      setChecked([]);
    }
  }, [selectedEditPatient]);


  useEffect(() => {
    const payload = {
      status: 1,
    };
    dispatch(fetchRpmVitalsRangeList(payload));
  }, []);

  const handlePatientVitalConfiguration = () => {
    if (!checked || checked.length === 0) {
      handleNext();
      return;
    }

    const patientVitalsConfigList = {
      bloodGlucose: 0,
      bmi: 0,
      diastolic: 0,
      heartRate: 0,
      height: 0,
      respiratoryRate: 0,
      spo2: 0,
      systolic: 0,
      temperature: 0,
      weight: 0,
      breathing: 0,
      pulse: 0,
      spirometry: 0,
      createdBy: loggedUser?.user?.userId,
      modifiedBy: loggedUser?.user?.userId,
      status: 1,
    };

    if (selectedEditPatient) {
      patientVitalsConfigList.patientId = selectedEditPatient.patientId;
    }

    const patientVitalsRangeList = [];

    checked.forEach((vital) => {
      const code = vital.vitalCode;

      // Enable the relevant field in config list
      switch (code) {
        case "BPS":
          patientVitalsConfigList.systolic = 1;
          break;
        case "BPD":
          patientVitalsConfigList.diastolic = 1;
          break;
        case "BMI":
          patientVitalsConfigList.bmi = 1;
          break;
        case "HI":
          patientVitalsConfigList.height = 1;
          break;
        case "WE":
          patientVitalsConfigList.weight = 1;
          break;
        case "pulse":
          patientVitalsConfigList.pulse = 1;
          break;
        case "SPO2":
          patientVitalsConfigList.spo2 = 1;
          break;
        case "TP":
          patientVitalsConfigList.temperature = 1;
          break;
        case "BG":
          patientVitalsConfigList.bloodGlucose = 1;
          break;
        case "RR":
          patientVitalsConfigList.respiratoryRate = 1;
          break;
        case "HR":
          patientVitalsConfigList.heartRate = 1;
          break;
        case "breathing":
          patientVitalsConfigList.breathing = 1;
          break;
        case "spirometry":
          patientVitalsConfigList.spirometry = 1;
          break;
        default:
          break;
      }

      const rangeItem = {
        createdBy: loggedUser?.user?.userId,
        modifiedBy: loggedUser?.user?.userId,
        name: vital.name,
        status: 1,
        vitalCode: vital.vitalCode,
      };

      if (vital.minimumNormalRange !== undefined) {
        rangeItem.minimumNormalRange = vital.minimumNormalRange;
        rangeItem.maximumNormalRange = vital.maximumNormalRange;
        rangeItem.minimumAbnormalRange = vital.minimumAbnormalRange;
        rangeItem.maximumAbnormalRange = vital.maximumAbnormalRange;
      }

      if (selectedEditPatient) {
        rangeItem.patientCode = selectedEditPatient.patientId;
      }

      patientVitalsRangeList.push(rangeItem);
    });

    const payload = {
      ...registrationPayload,
      patientVitalsConfigList,
      patientVitalsRangeList,
    };

    dispatch(handleSetPatientRegistrationPayload(payload));
    handleNext();
  };

  const handleVitalCheckUnCheck = (updatedVital) => {
    setChecked(updatedVital);
  };

  return (
    <div className="p-3">
      <div className="flex justify-between items-center py-3 px-6 sticky top-3">
        <div className="">
          <h1 className="font-bold text-xl">Configuration - Set Vitals</h1>
        </div>
      </div>
      <div
        className={`${
          isLoading === false && vitalRangesList?.length === 0
            ? "w-full flex justify-center items-center"
            : "overflow-y-scroll h-[23rem] scrollWidth"
        }`}
      >
        {isLoading && vitalRangesList?.length === 0 ? (
          <div className="flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : vitalRangesList?.length === 0 ? (
          <div className="flex flex-col items-center justify-center">
            <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
            <p className="font-medium text-xl">No data found!!</p>
          </div>
        ) : (
          <div>
            <VitalConfigurationTable
              data={vitalRangesList}
              totalCount={vitalRangesList?.length}
              handleVitalCheckUnCheck={handleVitalCheckUnCheck}
              checked={checked}
            />
          </div>
        )}
      </div>
      <div className="mt-8">
        <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
          <button
            disabled={currPageView === 1}
            className={`${
              currPageView > 1 ? "block" : "hidden"
            } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
            onClick={handlePrevious}
          >
            Previous
          </button>
          <button
            className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border bg-white border-brand-primaryColor font-semibold custom-button-shadow"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
            onClick={handlePatientVitalConfiguration}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Index;
